export const formatTitle = (title) => {
	if (title.split(": ").length > 1) {
		return title.split(": ")[1];
	}
	return title;
};

export const formatTime = (start, end) => {
	const s = new Date(start);
	const e = new Date(end);
	const doubleDigitStartHour =
		(s.getHours() >= 10 && s.getHours() <= 12) ||
		(s.getHours() >= 10 && s.getHours() <= 12);
	const doubleDigitEndHour =
		(e.getHours() >= 10 && e.getHours() <= 12) ||
		(e.getHours() >= 10 && e.getHours() <= 12);

	return `${s
		.toLocaleTimeString()
		.slice(
			0,
			doubleDigitStartHour ? 5 : 4
		)}AM - ${e
		.toLocaleTimeString()
		.slice(0, doubleDigitEndHour ? 5 : 4)}PM`;
};
export const formatAddress = (formattedAddress, location) => {
	if (formattedAddress) {
		return formattedAddress
			.split(", ")
			.slice(0, 2)
			.join(", ");
	}
	if (location) {
		return location
			.split(", ")
			.slice(0, 2)
			.join(", ");
	}
	return "";
};
